import React, { useState } from "react";
import { FaUserMd, FaMinus, FaPlus, FaHeartbeat,  FaNotesMedical, FaCapsules, FaHospital, FaAmbulance, FaLaptopMedical, FaHelicopter, FaShieldAlt } from "react-icons/fa";
import Medpalm from "../../../assests/Healthcareprovider/emergency.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
        "icon": "<FaAmbulance className='text-[#2a627a] text-3xl' />",
        "title": "Emergency Response",
        "description": "GPS-tracked ambulances ensure rapid response to emergencies. Paramedics provide critical pre-hospital care, including CPR, wound treatment, airway management, and trauma stabilization, maximizing survival chances before hospital arrival."
    },
    {
        "icon": "<FaHospital className='text-[#2a627a] text-3xl' />",
        "title": "24/7 Emergency Care",
        "description": "Our fully equipped emergency rooms operate around the clock with trauma specialists, advanced life support systems, and real-time diagnostics. Immediate interventions for strokes, heart attacks, respiratory distress, and severe injuries are always available."
    },
    {
        "icon": "<FaUserMd className='text-[#2a627a] text-3xl' />",
        "title": "Critical Care & Trauma Services",
        "description": "State-of-the-art trauma centers equipped with ventilators, defibrillators, and real-time patient monitoring provide life-saving treatments. Expert trauma teams handle severe injuries and critical conditions with precision and efficiency."
    },
    {
        "icon": "<FaHeartbeat className='text-[#2a627a] text-3xl' />",
        "title": "Cardiac & Stroke Emergency",
        "description": "Specialized response teams provide rapid cardiac and stroke intervention, including thrombolytic therapy, cardiac catheterization, and clot retrieval. Real-time ECG monitoring and advanced imaging improve survival and recovery outcomes."
    },
    {
        "icon": "<FaHelicopter className='text-[#2a627a] text-3xl' />",
        "title": "Air Ambulance Services",
        "description": "Helicopter emergency transport for critically ill or injured patients ensures swift medical attention in remote or inaccessible areas. Onboard medical teams provide urgent care en route to specialized hospitals."
    },
    {
        "icon": "<FaCapsules className='text-[#2a627a] text-3xl' />",
        "title": "Emergency Medication & Treatment",
        "description": "Immediate administration of critical medications, IV fluids, and life-saving treatments for severe allergic reactions, poisoning, acute infections, and shock. Rapid response protocols enhance patient recovery."
    },
    {
        "icon": "<FaFileMedical className='text-[#2a627a] text-3xl' />",
        "title": "Real-time Patient Monitoring",
        "description": "Portable ECGs, pulse oximeters, automated defibrillators, and telemetry systems ensure continuous tracking of vital signs. Real-time data enhances decision-making for emergency responders and hospital teams."
    },
    {
        "icon": "<FaShieldAlt className='text-[#2a627a] text-3xl' />",
        "title": "Disaster & Mass Casualty Management",
        "description": "Comprehensive disaster response with mobile emergency units, crisis intervention teams, and triage coordination. Our mass casualty protocols include mobile surgical stations and rapid on-site stabilization for large-scale emergencies."
    }
]


const features = [
    { icon: <FaAmbulance className="text-[#2a627a] text-lg" />, text: "Fast and efficient ambulance dispatch for emergency response." },
    { icon: <FaHeartbeat className="text-[#2a627a] text-lg" />, text: "Advanced life-saving interventions for cardiac and trauma patients." },
    { icon: <FaUserMd className="text-[#2a627a] text-lg" />, text: "24/7 access to emergency medical professionals and specialists." },
    { icon: <FaCapsules className="text-[#2a627a] text-lg" />, text: "Immediate administration of emergency medications and pain relief." },
    { icon: <FaHelicopter className="text-[#2a627a] text-lg" />, text: "Air ambulance transport for critical patients requiring urgent care." },
    { icon: <FaShieldAlt className="text-[#2a627a] text-lg" />, text: "Emergency preparedness and disaster management services." }
];

const benefits = [
    { icon: <FaHospital className="text-[#2a627a] text-lg" />, text: "Reduced response time and faster access to emergency care." },
    { icon: <FaUserMd className="text-[#2a627a] text-lg" />, text: "Highly trained emergency medical staff and trauma specialists." },
    { icon: <FaNotesMedical className="text-[#2a627a] text-lg" />, text: "Seamless coordination between emergency teams and hospitals." },
    { icon: <FaLaptopMedical className="text-[#2a627a] text-lg" />, text: "Real-time patient data sharing for efficient treatment decisions." },
    { icon: <FaCapsules className="text-[#2a627a] text-lg" />, text: "Rapid administration of life-saving medications and treatments." },
    { icon: <FaShieldAlt className="text-[#2a627a] text-lg" />, text: "Preparedness for natural disasters and mass casualty events." }
];
const cmsFeatures = [
    {
        icon: <FaUserMd className="text-[#2a627a] text-lg" />,
        role: "Emergency Physician",
        text: "Diagnose and treat critically ill patients, stabilize conditions, and coordinate emergency care."
    },
    {
        icon: <FaAmbulance className="text-[#2a627a] text-lg" />,
        role: "Paramedic",
        text: "Provide pre-hospital care, perform emergency medical procedures, and transport patients safely."
    },
    {
        icon: <FaHospital className="text-[#2a627a] text-lg" />,
        role: "Emergency Nurse",
        text: "Monitor patient vitals, assist in trauma care, and support life-saving medical interventions."
    },
    {
        icon: <FaShieldAlt className="text-[#2a627a] text-lg" />,
        role: "Disaster Response Team",
        text: "Coordinate emergency response efforts during natural disasters, accidents, and mass casualty events."
    },
    {
        icon: <FaHelicopter className="text-[#2a627a] text-lg" />,
        role: "Air Ambulance Crew",
        text: "Transport critically ill patients via air ambulance and provide in-flight emergency care."
    },
    {
        icon: <FaLaptopMedical className="text-[#2a627a] text-lg" />,
        role: "Emergency Medical Coordinator",
        text: "Manage emergency response logistics, dispatch ambulances, and communicate with hospitals."
    }
];

const EmergencyServices = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="font-semibold text-[30px] bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800  justify-center items-center flex">Emergency Services - <span className="text-gray-800">HIKEHEALTH GS</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        "Providing rapid, life-saving care with efficiency, accuracy, and patient-centered responsiveness."
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]"> What is Emergency Services?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                        Emergency services provide immediate medical care for critical conditions, accidents, and life-threatening situations.

At HIKEHEALTH GS, we enhance emergency response with digital solutions for faster coordination, real-time data access, and improved patient outcomes.
                        </p>
                    </div>
                </section>

                {/* Role in AI&Machine */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in Emergency Services
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default EmergencyServices;
